import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import NavigationTitle from '../../../../Theme/Fonts/NavigationTitle'
import { mapSpaceValue } from '../../../../Layouts/LayoutUtils'
import DartsScore from './HelperClass/Score'
import { LegThrowProps } from './Types'

const LegThrow: FunctionComponent<LegThrowProps> = ({
    homeScore,
    awayScore,
    throwResult,
    throws,
    scoreType = 'STANDARD',
    isAway,
    spaceX,
    spaceY,
    spaceBottom,
    spaceTop,
}) => {
    const dartsScore = (
        <DartsScore
            score={throwResult ? `${throwResult}` : undefined}
            caption={throws}
            type={scoreType}
            scorePosition={isAway ? 'right' : 'left'}
        />
    )
    return (
        <Grid
            horizontal
            paddingY={4}
            paddingX={5}
            centerVertical
            border={1}
            borderColor="moon-2"
            borderRadius="8px"
            backgroundColor="pearl"
            marginX={mapSpaceValue(spaceX)}
            marginY={mapSpaceValue(spaceY)}
            marginTop={mapSpaceValue(spaceTop)}
            marginBottom={mapSpaceValue(spaceBottom)}
        >
            {isAway ? <Grid /> : dartsScore}
            <Grid noExpand width={30} marginRight={1}>
                <NavigationTitle color="onyx" textAlign="right">
                    {`${homeScore}`}
                </NavigationTitle>
            </Grid>
            <NavigationTitle color="onyx">:</NavigationTitle>
            <Grid noExpand width={30} marginLeft={1}>
                <NavigationTitle color="onyx" textAlign="left">
                    {`${awayScore}`}
                </NavigationTitle>
            </Grid>
            {!isAway ? <Grid /> : dartsScore}
        </Grid>
    )
}
export default LegThrow
